"use strict";

exports.__esModule = true;
exports.createEnhancedContext = createEnhancedContext;
exports.createHOC = createHOC;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["value", "controller", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Create a context with hoc and optionally a default controller.
 */
function createEnhancedContext(_ref) {
  var propName = _ref.propName,
    defaultController = _ref.defaultController;
  var EnhancedContext = /*#__PURE__*/_react["default"].createContext();
  var componentName = "" + propName.charAt(0).toUpperCase() + propName.slice(1);
  var LocalProvider = EnhancedContext.Provider;
  EnhancedContext.Consumer.displayName = componentName + "ContextConsumer";
  var EnhancedProvider = function EnhancedProvider(props) {
    var value = props.value,
      _props$controller = props.controller,
      Controller = _props$controller === void 0 ? defaultController : _props$controller,
      children = props.children,
      extra = _objectWithoutPropertiesLoose(props, _excluded);
    if (value === undefined && Controller) {
      return /*#__PURE__*/_react["default"].createElement(Controller, extra, function (value) {
        return /*#__PURE__*/_react["default"].createElement(LocalProvider, {
          value: value
        }, children);
      });
    }
    return /*#__PURE__*/_react["default"].createElement(LocalProvider, {
      value: value
    }, children);
  };
  EnhancedContext.Provider = EnhancedProvider;
  EnhancedContext.withContext = createHOC(propName, EnhancedContext.Consumer);
  return EnhancedContext;
}
function createHOC(propName, ContextConsumer) {
  return function (TargetComponent) {
    function withTarget(props) {
      return /*#__PURE__*/_react["default"].createElement(ContextConsumer, null, function (consumerProps) {
        var _Object$assign;
        return /*#__PURE__*/_react["default"].createElement(TargetComponent, Object.assign({}, props, (_Object$assign = {}, _Object$assign[propName] = consumerProps, _Object$assign)));
      });
    }
    withTarget.displayName = "with" + propName.charAt(0).toUpperCase() + propName.slice(1) + "(" + (TargetComponent.displayName || TargetComponent.name || "Unknown") + ")";
    return withTarget;
  };
}